import { HiUserCircle } from "react-icons/hi2";

export const ProfileIcon = ({ width, height, color, ...props }) => (
  <HiUserCircle
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
